/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/
;(() => {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ "./src/js/components/predictive-search.js":
      /*!************************************************!*\
  !*** ./src/js/components/predictive-search.js ***!
  \************************************************/
      /***/ () => {
        class PredictiveSearch extends HTMLElement {
          constructor() {
            super()

            this.input = this.querySelector('input[type="search"]')
            this.form = this.querySelector(".form")
            this.predictiveSearchResults = this.querySelector(".predictive-search-results")
            this.input.addEventListener(
              "input",
              this.debounce((event) => {
                this.onChange(event)
              }, 300).bind(this),
            )
          }

          onChange() {
            const searchTerm = this.input.value.trim()

            if (!searchTerm.length) {
              this.close()
              return
            }

            this.getSearchResults(searchTerm)
          }

          getSearchResults(searchTerm) {
            fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
              .then((response) => {
                if (!response.ok) {
                  var error = new Error(response.status)
                  this.close()
                  throw error
                }

                return response.text()
              })
              .then((text) => {
                const resultsMarkup = new DOMParser()
                  .parseFromString(text, "text/html")
                  .querySelector("#shopify-section-predictive-search").innerHTML
                this.predictiveSearchResults.innerHTML = resultsMarkup
                this.open()
              })
              .catch((error) => {
                this.close()
                throw error
              })
          }

          open() {
            this.predictiveSearchResults.style.display = "block"
          }

          close() {
            this.predictiveSearchResults.style.display = "none"
          }

          debounce(fn, wait) {
            let t
            return (...args) => {
              clearTimeout(t)
              t = setTimeout(() => fn.apply(this, args), wait)
            }
          }
        }

        if (!customElements.get("predictive-search")) {
          customElements.define("predictive-search", PredictiveSearch)
        }

        class PredictiveSearchMobile extends PredictiveSearch {}
        if (!customElements.get("predictive-search-mobile")) {
          customElements.define("predictive-search-mobile", PredictiveSearchMobile)
        }
      },
    /******/
  }
  /************************************************************************/
  /******/
  /******/ // startup
  /******/ // Load entry module and return exports
  /******/ // This entry module can't be inlined because the eval-source-map devtool is used.
  /******/ var __webpack_exports__ = {}
  /******/ __webpack_modules__["./src/js/components/predictive-search.js"]()
  /******/
  /******/
})()
